export const addLogo = () => {
    const jobTiles = document.querySelectorAll(".attrax-vacancy-tile");

    if (!jobTiles) {
        return;
    }

    jobTiles.forEach((jobTile) => {
        let logoWrapper = document.createElement("div");
        logoWrapper.classList.add("attrax-vacancy-tile__logo-wrapper");
        jobTile.prepend(logoWrapper);
    });
};

export const logoReplacer = () => {
    const jobOptionClass: string = ".attrax-vacancy-tile__option-brand--";

    const optionArray: Array<string> = [
        "art-otel",
        "country-inn-suites",
        "park-plaza",
        "prize-hotels",
        "radisson",
        "park-inn-by-radisson",
        "radisson-blu",
        "radisson-collection",
        "radisson-individuals",
        "radisson-red",
        "radisson-emea",
        "prize-by-radisson",
        "country-inn-suites-by-radisson"
    ];

    optionArray.forEach((option) => {
        const className = jobOptionClass + option;

        if (document.getElementsByClassName(className)) {
            const filePath = `url("/Blob/images/logos/${option}.webp")`;

            const foundClass: Element[] = Array.from(
            document.querySelectorAll(className)
        );

            foundClass.forEach((option) => {
                const parentTile: HTMLElement | null = option.closest(
                    ".attrax-vacancy-tile"
                );

                if (!parentTile) return;

                const logowrapper: HTMLElement | null = parentTile.querySelector(
                ".attrax-vacancy-tile__logo-wrapper"
            );

                if (!logowrapper) return;
                
                logowrapper.style.backgroundImage = filePath;
            });
        }
    });
};

export const brandClassAssignment = () => {
    const brandtiles = document.querySelectorAll(
        ".attrax-vacancy-tile__option-brand"
    );

    if (!brandtiles) {
        return;
    }

    brandtiles.forEach((brandtile) => {
        const brandclass = [...brandtile.classList].find((el) =>
            el.includes("attrax-vacancy-tile__option-brand--")
        );

        if (!brandclass) {
            return;
        }

        const closestTile = brandtile.closest(".attrax-vacancy-tile");
        if (closestTile) {
            closestTile.classList.add(brandclass);
        }
    });
};

export const setActive = () => {
    const jobtiles = document.querySelectorAll(".attrax-vacancy-tile");

    if (!jobtiles) {
        return;
    }

    jobtiles.forEach((jobtile) => {
        jobtile.classList.add("attrax-vacancy-tile--active");
    });
};

export const flagEmptySalaryValues = () => {
    const listWidget = document.querySelector(".attrax-list-widget.attrax-list-widget--has-items");
    if (!listWidget) {
        return;
    }
    const salaryValues = listWidget.querySelectorAll<HTMLElement>(".attrax-vacancy-tile__salary .attrax-vacancy-tile__salary-value")
    if (!salaryValues.length) {
        return;
    }

    salaryValues.forEach((el) => {
        const hasText = el.textContent?.trim() !== "";
        el.classList.toggle("attrax-vacancy-tile__salary-value--empty", !hasText);
    });
};
